import React from "react";
export class Chat extends React.Component { 
   render () {
       return null;
   }
}